import React, { useEffect } from "react";
import Slider from "react-slick";
import { getBanners } from "./main-slider.service";
import { Link } from "react-router-dom";

interface SlideContentProps {
  title: string;
  subtitle: string;
  description: string;
  price: string;
  imageUrl: string;
  altText: string;
}

interface IBanner {
  isActive: boolean;
  title: string;
  buttonText: string;
  image: {
    key: string;
  };
  createdAt: string;
  updatedAt: string;
  id: string;
}

const SlideContent: React.FC<IBanner> = ({ buttonText, title, image, id }) => (
  <div
    className="ec-slide-item d-flex slide-1"
    style={{
      backgroundImage: `url(https://d1gdand68muq63.cloudfront.net/banners/original/${image.key})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "86vh",
    }}
  >
    <img
      src={`https://d1gdand68muq63.cloudfront.net/banners/original/${image.key}`}
      className="main_banner_arrow_img"
      alt=""
    />
    <div className="container align-self-center">
      <div className="row">
        <div className="col-xl-6 col-lg-7 col-md-7 col-sm-7 align-self-center">
          <div className="ec-slide-content slider-animation">
            <h1 className="ec-slide-title">{title}</h1>
            {buttonText !== "" && (
              <Link to="/products" className="btn btn-lg btn-secondary">
                {buttonText}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const MainSlider: React.FC = () => {
  const [slides, setSlides] = React.useState<IBanner[]>([]);
  useEffect(() => {
    getBanners().then((response) => {
      const banners = response.data;
      if (banners.length === 1) {
        setSlides([...banners, ...banners]);
      } else {
        setSlides(banners);
      }
    });
  }, []);
  return (
    <div className="ec-main-slider section section-space-mb">
      <Slider className="ec-slider" {...settings}>
        {slides.map((slide) => (
          <SlideContent key={slide.id} {...slide} />
        ))}
      </Slider>
    </div>
  );
};

export default MainSlider;
